import { atom } from "recoil";

export const groupEditModalStore = atom({
	key: "groupEditModalStore",
	default: {
		show: false,
		loaded: true,
		error: {
			text: "",
			code: 0,
			timestamp: 0,
		},
	},
});
